<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-10 mx-auto my-5">
        <Breadcrumb :items="breadcrumb" />
        <div class="d-flex justify-content-between align-items-center">
          <Typography
            text="Creación de nuevos procesos"
            variant="h1"
            class="m-0"
          />
          <Steps :step="step" :list="listProgress" />
        </div>

        <Typography
          text="En esta sección puedes registrar un nuevo litigio en la plataforma. Recuerda que los campos con * son obligatorios."
          variant="body"
          class="m-0 pt-3 mt-3 max-w-50"
        />
        <Typography
          :text="title[step]"
          variant="h2"
          class="m-0 pt-3 mt-3"
          color="#263238"
        />
        <section :class="['mt-4', step === 1 ? 'w-100' : 'w-75']">
          <form onsubmit="return false" @submit="submitData">
            <div :class="['row col-12 p-0 min-h-245', step !== 0 && 'd-none']">
              <div
                class="d-flex flex-column col-6 child-flex-0 space-y-8 justify-content-around"
              >
                <Select
                  label="Tipo de Demandante"
                  name="worker"
                  :options="options.plaintiff_type"
                  :value="formData.worker"
                  v-model="formData.worker"
                  :errors="computedErrors"
                  @input="validate('worker')"
                />
                <div class="d-flex justify-content-between space-x-4">
                  <Input
                    type="text"
                    label="Cedula"
                    name="cc"
                    @input="(event) => (formData.cc = event.target.value)"
                    :errors="errors"
                    @keypress="validate('cc')"
                    :value="formData.cc"
                  />
                  <Input
                    type="number"
                    label="Edad"
                    name="age"
                    @input="
                      (event) =>
                        (formData.age = event.target.value
                          ? parseInt(event.target.value)
                          : null)
                    "
                    :errors="errors"
                    @keypress="validate('age')"
                    col="4"
                    :value="formData.age"
                  />
                </div>
                <Input
                  type="text"
                  label="Nombre del Demandante"
                  name="demandante"
                  @input="(event) => (formData.demandante = event.target.value)"
                  :errors="errors"
                  @keypress="validate('demandante')"
                  required
                  :value="formData.demandante"
                />
              </div>
              <div
                class="d-flex flex-column col-6 child-flex-0 space-y-8 justify-content-around"
              >
                <Select
                  label="Ciudad"
                  name="city"
                  :options="options.cities"
                  :value="formData.city"
                  v-model="formData.city"
                  :errors="errors"
                  @input="validate('city')"
                  required
                />
                <Select
                  label="Fueros"
                  name="fuero"
                  :options="options.charters"
                  :value="formData.fuero"
                  multiple
                  v-model="formData.fuero"
                  :errors="errors"
                  @input="validate('fuero')"
                  information="Puede seleccionarse más de una opción"
                />
                <Select
                  label="Sindicatos"
                  name="sindicato"
                  :options="options.unions"
                  :value="formData.sindicato"
                  multiple
                  v-model="formData.sindicato"
                  :errors="errors"
                  @input="validate('sindicato')"
                  information="Puede seleccionarse más de una opción"
                />
              </div>
            </div>
            <div :class="['row col-12 p-0 min-h-245', step !== 1 && 'd-none']">
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Date
                  name="dateNotification"
                  label="Fecha de notificación"
                  v-model="formData.dateNotification"
                  :value="formData.dateNotification"
                  :errors="errors"
                  @input="validate('dateNotification')"
                />
                <Input
                  type="text"
                  label="No. de radicado"
                  name="radicado"
                  @input="(event) => (formData.radicado = event.target.value)"
                  :errors="errors"
                  :value="formData.radicado"
                  @keypress="validate('radicado')"
                  required
                />
                <Select
                  label="Tipo de proceso"
                  name="type"
                  :options="options.process_types"
                  :value="formData.type"
                  v-model="formData.type"
                  :errors="errors"
                  @input="validate('type')"
                  required
                />
                <Select
                  label="Objeto"
                  name="object"
                  :options="options.objects"
                  :value="formData.object"
                  v-model="formData.object"
                  :errors="errors"
                  @input="validate('object')"
                  required
                />
              </div>
              <div class="d-flex flex-column col-4">
                <Textarea
                  label="Causa"
                  name="causa"
                  @input="(event) => (formData.causa = event.target.value)"
                  :errors="errors"
                  class="mb-2"
                  rows="4"
                  :value="formData.causa"
                  required
                />
                <Input
                  type="number"
                  label="Cuantía"
                  name="cuantia"
                  class="mt-3"
                  :value="formData.cuantia"
                  @input="
                    (event) => (formData.cuantia = Number(event.target.value))
                  "
                  :errors="errors"
                  @keypress="validate('cuantia')"
                />
                <Select
                  label="Distrito"
                  name="court_places"
                  :options="options.court_places"
                  :value="formData.court_places"
                  v-model="formData.court_places"
                  :errors="errors"
                  @input="filterCourt()"
                  class="mt-5"
                />
              </div>
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Select
                  label="Tutela"
                  name="tutela"
                  :options="options.guardianship_action"
                  :value="formData.tutela"
                  v-model="formData.tutela"
                  :errors="errors"
                  @input="validate('tutela')"
                  required
                />
                <Select
                  label="Querella"
                  name="querella"
                  :options="options.complain"
                  :value="formData.querella"
                  v-model="formData.querella"
                  :errors="errors"
                  @input="validate('querella')"
                  required
                />
                <Select
                  label="Provisión"
                  name="provition"
                  :options="options.provision"
                  :value="formData.provition"
                  v-model="formData.provition"
                  :errors="errors"
                  @input="validate('provition')"
                  required
                />
                <Select
                  label="Juzgado"
                  name="juzgado"
                  :options="options.courts"
                  :value="formData.juzgado"
                  v-model="formData.juzgado"
                  :errors="errors"
                  @input="validate('juzgado')"
                  class="mt-5"
                  required
                />
              </div>
            </div>
            <div :class="['row col-12 p-0 min-h-245', step !== 2 && 'd-none']">
              <div class="d-flex flex-column col-6 child-flex-0 space-y-12">
                <Select
                  label="Demandados"
                  name="demandados"
                  :options="options.defendants"
                  :value="formData.demandados"
                  v-model="formData.demandados"
                  multiple
                  :errors="errors"
                  @input="validate('demandados')"
                  required
                  information="Puede seleccionarse más de una opción"
                />
                <Select
                  label="Pruebas"
                  name="tests"
                  :options="options.evidence"
                  :value="formData.tests"
                  v-model="formData.tests"
                  :errors="errors"
                  @input="validate('tests')"
                  required
                />
                <Select
                  label="Prescripción"
                  name="prescription"
                  :options="options.prescription"
                  :value="formData.prescription"
                  v-model="formData.prescription"
                  :errors="errors"
                  @input="validate('prescription')"
                  required
                />
              </div>
              <div class="d-flex flex-column col-6 space-y-12 child-flex-0">
                <Select
                  label="Area"
                  name="area"
                  :options="options.areas"
                  :value="formData.area"
                  v-model="formData.area"
                  :errors="errors"
                  @input="validate('area')"
                  required
                />
                <Select
                  label="Abogado"
                  name="layer"
                  :options="options.lawyers"
                  :value="formData.layer"
                  v-model="formData.layer"
                  :errors="errors"
                  @input="validate('layer')"
                  required
                />
                <Select
                  label="Estado"
                  name="status"
                  :options="options.status"
                  :value="formData.status"
                  v-model="formData.status"
                  :errors="errors"
                  @input="validate('status')"
                  required
                />
              </div>
            </div>
            <div class="container-buttons">
              <Button
                label="Cancelar"
                showIcon
                icon="cancel"
                variant="secondary"
                colorIcon="#5D5FEF"
                @click="confirmCancel"
                v-if="step === 0"
              />
              <Button
                label="Anterior"
                showIcon
                icon="prev"
                variant="secondary"
                reverIcon
                colorIcon="#5D5FEF"
                @click="prevStep"
                v-if="step !== 0"
                :disabled="isBusy"
              />
              <Button
                label="Siguiente"
                showIcon
                icon="next"
                variant="primary"
                class="ml-4"
                @click="nextStep"
                v-if="step !== 2"
              />
              <Button
                type="submit"
                showIcon
                icon="check"
                variant="primary"
                class="ml-4"
                v-show="step === 2"
                :disabled="isBusy"
              >
                <span class="mr-1">Finalizar</span>
                <b-spinner v-if="isBusy" />
              </Button>
            </div>
          </form>
        </section>
      </div>
      <!--Modal Section-->
      <div>
        <b-modal id="modal-confirm" centered hide-footer>
          <div class="text-center mb-4">
            <img
              src="@/assets/images/icons/warning_.svg"
              width="60px"
              height="60px"
              class="mx-auto"
            />
          </div>
          <Typography
            text="¿Estás seguro de cancelar la creación del proceso?"
            variant="h3"
            class="text-center"
          />
          <div class="row justify-content-center mt-4" v-if="!isEdit">
            <Button label="Si, Cancelar" variant="secondary" @click="goBack" />
            <Button
              label="Continuar Creación"
              variant="primary"
              class="ml-4"
              @click="closeModal('modal-confirm')"
            />
          </div>
          <div class="row justify-content-center mt-4" v-if="isEdit">
            <Button label="Seguir Editando" variant="secondary" />
            <Button label="Guardar Cambios" variant="primary" class="ml-4" />
          </div>
        </b-modal>
        <b-modal id="modal-message" centered hide-footer>
          <div class="text-center mb-4">
            <img
              src="@/assets/images/icons/checkbox-circle-line.svg"
              width="60px"
              height="60px"
              class="mx-auto"
            />
          </div>
          <Typography
            text="¡Proceso creado!"
            variant="h2"
            class="text-center"
          />
          <Typography
            text="Recuerde actualizar regularmente y establecer controles "
            variant="body"
            class="text-center"
            v-if="!isEdit"
          />
          <div class="row justify-content-center mt-4" v-if="!isEdit">
            <Button label="Entendido" variant="primary" @click="goBack" />
            <Button
              label="Evaluar"
              variant="secondary"
              class="ml-4"
              @click="goEvaluate"
            />
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useProcess } = useLegal();
const { useCreate } = useProcess();

export default useCreate;
</script>

<style lang="scss" scoped src="./CreateProcess.scss"></style>
